export default "__VITE_ASSET__DR6P4rc0__"